import { createSelector } from 'reselect';
import { RootState } from 'store';
import adapter from './clientManagers.adapter';
import { REDUCER_KEY } from './clientManagers.consts';
import { ClientManagerParams } from './clientManagers.types';

const selectors = adapter.getSelectors(
  (state: RootState) => state[REDUCER_KEY],
);
export const { selectIds, selectTotal, selectAll } = selectors;

export const selectById = (
  state: RootState,
  id: number,
): ClientManagerParams | null => selectors.selectById(state, id) || null;

export const selectCurrentClientManagerId = (state: RootState): number =>
  state[REDUCER_KEY].current;

export const selectAllClientManagers = createSelector(
  state => selectors.selectAll(state),
  clientManagers => clientManagers || [],
);

export const selectCurrentClientManager = createSelector(
  selectCurrentClientManagerId,
  selectAllClientManagers,
  (currentId: number, clientManagers: ClientManagerParams[]) =>
    clientManagers.find(({ id }: { id: number }) => id === currentId),
);

export const selectClientManagerAsOptions = createSelector(
  selectAllClientManagers,
  (allClientManagers: ClientManagerParams[]) =>
    allClientManagers.map(
      ({
        id,
        firstName,
        lastName,
      }: {
        id: number;
        firstName: string;
        lastName: string;
      }) => ({
        id,
        firstName: firstName,
        lastName: lastName,
      }),
    ),
);

export function selectClientManager(
  state: RootState,
  clientManagerId: number,
): ClientManagerParams | undefined {
  return selectors.selectById(state, clientManagerId) || undefined;
}

export const selectClientManagerFullName = (
  state: RootState,
  clientManagerId: number,
): string => {
  const clientManager = selectors.selectById(state, clientManagerId);
  return clientManager?.firstName + ' ' + clientManager?.lastName || '';
};
